import React from "react";
import {Box,CircularProgress} from "@mui/material";

const Loader: React.FC = ()=>{
    return (<Box
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1300,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
        }}
    >
        <CircularProgress />
    </Box>)
}


export  default  Loader